<template>
    <div class="detaiBox">
      <headTotal></headTotal>
      <div class="detailContainer">
        <detail v-if="gameInfoShow" :row="row"></detail>
        <detailJc v-if="jiaochengShow" :row="row"></detailJc>
      </div>
    </div>
</template>
<script>
import headTotal from "@/components/qt/headTotal.vue";
import detail from "@/components/gameDetail/index.vue";
import detailJc from "@/components/gameDetail/indexJiaoCheng.vue";
import {getGameDetail} from "@/api/qt/common";

export default {

  components: {headTotal,detail,detailJc},
  data(){
    return {
      row:{},
      jiaochengShow:false,
      gameInfoShow:false
    }
  },
  created(){

    let info=this.getUrlParams();
    let params=info.split("-")

    this.row={
      id:params[0],
      cls_ids:params[1],
    }
    this.showDetail(this.row)
    // this.row=JSON.parse(info);
  },
  methods:{
    // getGameInfo(){
    //
    //   getGameDetail(this.row.id).then((res)=>{
    //
    //     this.row=res.data.data
    //     // if(this.row.cls_ids.includes(',41,')){
    //     //   this.jiaochengShow=true;
    //     // }else{
    //     //   this.gameInfoShow=true;
    //     // }
    //   })
    // },
    showDetail(row){
      if(row.cls_ids.includes(',41,')){
        this.jiaochengShow=true;
      }else{
        this.gameInfoShow=true;
      }
    },
    getUrlParams(){
      let reg=/\?info=(.*)/;

      let re=window.location.href.match(reg)
      return re[1]?re[1]:null;

    }
  }
}
</script>
<style>
  .detaiBox{
    width:80%;
    margin: auto;
    background-color: #fff;
    padding-bottom: 30px;
    position: relative;
  }

</style>